import Axios from '@/utils/axios'

const URL = '/agendamentos'

export default {
  buscaAgendamentosAbertos: () => Axios.get(`${URL}/abertos`)
}
